import 'uni-pages';import 'uni-h5';import Vue from 'vue'
import App from './App'
import api from 'networks/api/api.js'
import store from './stores/index.js'
import share from './utils/share.js'
import Vant from 'vant'
import 'vant/lib/index.css'
import CONFIG from '@/config'

// mix中包含分享和用户信息
Vue.mixin(share)
Vue.config.productionTip = false
Vue.prototype.$api = api
Vue.prototype.$store = store
Vue.use(Vant)
App.mpType = 'app'



import { wxShare } from './utils/wx.js'
import {init} from '@/utils/wx.js'
import VConsole from 'vconsole';
import uView from '@/uni_modules/uview-ui'
Vue.use(uView)
Vue.prototype.$wxShare = wxShare

// 默认初始进入先获取用户信息
store.dispatch('setUserInfo')

// 初始化wx js sdk
init()

if (process.env.NODE_ENV === 'development') { 
	const vConsole = new VConsole();
}






















































const app = new Vue({
    ...App,
		store
})
app.$mount()